define(
    "diy/undo-redo/Storage",
    [
        'jquery',
        'diy/undo-redo/constants',
        'diy/util/helper'
    ],
    /**
     *
     * @param {jquery} $
     * @param {module.undoRedo.constants} constants
     * @returns {*}
     */
    function ($, constants) {
        'use strict';
        var Storage;

        /**
         * @class module.undoRedo.Storage
         * @template module.undoRedo.Storage
         * @lends {module.undoRedo.Storage.prototype}
         * @constructor
         */
        Storage = Klazz.extend({

            /** @type {String} */
            sessionId: null,

            /** @type {String} */
            websiteId: null,

            /** @type {module.undoRedo.PouchAdapter} */
            database: null,

            /** @type {module.undoRedo.RemoteRequest} */
            backend: null,

            history: {
                undoList: [],
                redoList: [],
                lastEntry: {}
            },
            serverHistory: {
                undoList: [],
                redoList: [],
                lastEntry: {}
            },

            /**
             *
             * @param {module.undoRedo.RemoteRequest} backend
             */
            initialize: function (backend) {
                this.backend = backend;
            },

             // it has no constructor

            /**
             * Storage will be dependant on websiteId and sessionId
             * due to the fact that the user may have more than one contract on the same shard
             *
             * @param {module.undoRedo.PouchAdapter} database
             * @param {String} websiteId
             * @param {String} sessionId
             * @return {Promise|Q.Promise}
             */
            init: function (database, websiteId, sessionId) {
                this.database = database;
                this.websiteId = websiteId;
                this.sessionId = sessionId;
                return Q(true);
            },

            /**
             *
             * @param {Q} deferred
             * @param {Object} injectedData
             * @param {?Object[]} injectedData.undoList
             * @param {?Object[]} injectedData.redoList
             * @param {?Object} injectedData.lastEntry
             * @returns {promise|a.fn.promise|Q.promise|.n.promise}
             */
            useInjectedHistory: function (deferred, injectedData) {
                var data;
                if (injectedData && injectedData.undoList && injectedData.redoList) {
                    data = this.parseHistory(injectedData, this.markServerEntry);
                    deferred.resolve(data);
                } else {
                    deferred.reject({message:'invalid injected data', data: injectedData});
                }
                return deferred.promise;
            },
            /**
             *
             * @param deferred
             * @returns {Promise|Q.promise}
             * @private
             */
            loadServerHistory: function (deferred) {
                this.backend.loadHistory()
                    .then(
                    /**
                     *
                     * @param serverHistory {Object}
                     * @param serverHistory.undoList {?Object[]}
                     * @param serverHistory.redoList {?Object[]}
                     * @param serverHistory.lastEntry {?Object}
                     */
                    function (serverHistory) {
                        var data = this.parseHistory(serverHistory, this.markServerEntry);
                        deferred.resolve(data);
                    }.bind(this)
                )
                    .catch(function (error) {
                        deferred.reject(error);
                    });
                return deferred.promise;
            },
            /**
             * Load server history from server side
             *      or that history may be injected by using @param injectedData
             *
             * Returns promise resolved with formatted serverHistory
             * @param {Object=} injectedData
             * @param {?Object[]} injectedData.undoList
             * @param {?Object[]} injectedData.redoList
             * @param {?Object} injectedData.lastEntry
             * @returns {Promise|Q.promise}
             * @private
             */
            loadServer: function (injectedData) {
                var deferred = Q.defer();
                if (typeof injectedData === 'undefined') {
                    return this.loadServerHistory(deferred);
                } else {
                    return this.useInjectedHistory(deferred, injectedData);
                }
            },

            /**
             * Converts server payload to a common format
             *
             * @param object
             * @returns {*}
             * @private
             */
            markServerEntry: function (object) {
                return $.extend({}, object, {
                    executionType: constants.executionType.SERVER,
                    entryKey: object.entryId,
                    entryId: object.entryId,
                    undoSessionId: object.undoSessionId,
                    undoSessionIndex: 0,
                    manager: object.manager,
                    entryType: (object.entryType === 1) ? constants.types.UNDO : constants.types.REDO
                });
            },

            /**
             * Converts client payload to a common format
             *
             * @param object
             * @returns {*}
             * @private
             */
            markClientEntry: function (object) {
                return $.extend({}, object, {
                    executionType: constants.executionType.CLIENT,
                    entryKey: object._id,
                    entryType: object.type
                });
            },

            /**
             * Converts database loaded history to a common format
             *
             * @param history
             * @param callback
             * @returns {{undoList: Array, redoList: Array, lastEntry: {}}}
             * @private
             */
            parseHistory: function (history, callback) {

                var
                    index,
                    parsedHistory = {undoList: [], redoList: [], lastEntry: null};

                for (index = 0; index < history.undoList.length; index++) {
                    parsedHistory.undoList[index] = callback.call(this, history.undoList[index]);
                }

                for (index = 0; index < history.redoList.length; index++) {
                    parsedHistory.redoList[index] = callback.call(this, history.redoList[index]);
                }

                if (history.lastEntry && Object.keys(history.lastEntry).length !== 0) {
                    parsedHistory.lastEntry = callback.call(this, history.lastEntry);
                }

                return parsedHistory;
            },
            /**
             * Merges the server history with local stored history
             *
             * Process merges the client entries always after a server entry
             *  example:
             *      before merge:
             *          ServerHistory.undoList = [
             *              {server entry 1, ..., undoSessionId:'session1'},
             *              {server entry 2, ..., undoSessionId:'session2'},
             *              .....
             *              {server entry n, ..., undoSessionId:'sessionN'},
             *          ]
             *          localHistory.undoList = [
             *              {client entry 1, ..., undoSessionId:'session1'},
             *              {client entry 2, ..., undoSessionId:'session1'},
             *              {client entry 3, ..., undoSessionId:'session1'},
             *              .....
             *              {client entry 4, ..., undoSessionId:'session2'},
             *              {client entry 5, ..., undoSessionId:'session2'},
             *              .....
             *          ]
             *      after merge:
             *
             *          history.undoList = [
             *              {client entry 1, ..., undoSessionId:'session1'},
             *              {client entry 2, ..., undoSessionId:'session1'},
             *              {client entry 3, ..., undoSessionId:'session1'},
             *              {server entry 1, ..., undoSessionId:'session1'},
             *              {client entry 4, ..., undoSessionId:'session2'},
             *              {client entry 5, ..., undoSessionId:'session2'},
             *              {server entry 2, ..., undoSessionId:'session2'},
             *              .....
             *              {server entry n, ..., undoSessionId:'sessionN'},
             *          ]
             * Local entries that do not have an existing undoSessionId on any server side entries are deleted
             *
             * Returns resolved promise with merged history
             *
             * @param serverHistory
             * @returns {Promise|Q.promise}
             * @private
             */
            mergeWithLocalDatabase: function (serverHistory) {
                /**
                 * @info implement last entry support in client side if will be needed for notification center
                 *
                 * @type {{undoList: Array, redoList: Array, lastEntry: *}}
                 */
               var history = {
                    undoList: [],
                    redoList: [],
                    lastEntry: serverHistory.lastEntry
                };

                return this.loadLocalDatabase()
                    .then(function(localHistory){
                        localHistory = this.parseHistory(localHistory, this.markClientEntry);
                        return this.mergeLists(localHistory, serverHistory, history);
                    }.bind(this));
            },
            /**
             *
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} serverHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} localHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} history
             * @returns {Promise|Q.promise}
             * @private
             */
            mergeLists: function mergeLists(localHistory, serverHistory, history) {
                var availableSessions = [];

                history.undoList = this.mergeUndoList(serverHistory, localHistory, availableSessions);
                history.redoList = this.mergeRedoList(serverHistory, localHistory, availableSessions);

                return this.mergeUnmatched(serverHistory, localHistory, availableSessions, history)
                    .then(function(){
                        return Q(history);
                    });
            },
            /**
             * For undo list merge client side entries between server side entries
             *
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} serverHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} localHistory
             * @param {Array.<String>} availableSessions
             * @returns {Array}
             * @private
             */
            mergeUndoList: function mergeUndoList(serverHistory, localHistory, availableSessions) {
                var list = [], i, j, currentEntry, localEntry;

                if (serverHistory.undoList.length) {
                    for (i = serverHistory.undoList.length - 1; i >= 0; i--) {
                        currentEntry = serverHistory.undoList[i];
                        availableSessions.push(currentEntry.undoSessionId);
                        list.unshift(currentEntry);
                        for (j = 0; j < localHistory.undoList.length;) {
                            localEntry = localHistory.undoList[j];
                            if (currentEntry.undoSessionId === localEntry.undoSessionId) {
                                list.unshift(localEntry);
                                localHistory.undoList.splice(j, 1);
                            } else {
                                j++;
                            }
                        }
                    }
                }
                return list;
            },

            /**
             * For redo list merge client side entries between server side entries
             *
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} serverHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} localHistory
             * @param {Array.<String>} availableSessions
             * @returns {Array}
             * @private
             */
            mergeRedoList: function mergeRedoList(serverHistory, localHistory, availableSessions) {
                var list = [], i, j, currentEntry, localEntry;

                if (serverHistory.redoList.length) {
                    for (i = 0; i < serverHistory.redoList.length; i++) {
                        currentEntry = serverHistory.redoList[i];
                        availableSessions.push(currentEntry.undoSessionId);
                        list.push(currentEntry);
                        for (j = 0; j < localHistory.redoList.length;) {
                            localEntry = localHistory.redoList[j];
                            if (currentEntry.undoSessionId === localEntry.undoSessionId) {
                                list.push(localEntry);
                                localHistory.redoList.splice(j, 1);
                            } else {
                                j++;
                            }
                        }
                    }
                }
                return list;
            },
            /**
             * Add remaining local entries that have the undoSessionId in any server entries
             *  to the top of redo list
             * Delete unmatched local entries
             *
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} serverHistory
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} localHistory
             * @param {Array.<String>} availableSessions
             * @param {{undoList: Array, redoList: Array, lastEntry: {}}} history
             * @returns {Promise|Q.promise}
             * @private
             */
            mergeUnmatched: function mergeUnmatched(serverHistory, localHistory, availableSessions, history) {
                var entriesToBeDeleted = [], i, localEntry;

                /**
                 * add remaining local entries that have the undoSessionId in any server entries
                 * to the top of redo list
                 */
                for (i = localHistory.redoList.length - 1; i >= 0; i--) {
                    localEntry = localHistory.redoList[i];
                    if (availableSessions.indexOf(localEntry.undoSessionId) !== -1) {
                        history.redoList.unshift(localEntry);
                        localHistory.redoList.splice(i, 1);
                    } else {
                        i--;
                    }
                }

                /**
                 * delete the local entries that did not matched so far
                 * (there can not be an entry at the top/bottom of undo list)
                 */
                for (i = 0; i < localHistory.undoList.length; i++) {
                    localEntry = localHistory.undoList[i];
                    if (availableSessions.indexOf(localEntry.undoSessionId) === -1) {
                        entriesToBeDeleted.push(localEntry.entryKey);
                    }
                }
                for (i = 0; i < localHistory.redoList.length; i++) {
                    localEntry = localHistory.redoList[i];
                    if (availableSessions.indexOf(localEntry.undoSessionId) === -1) {
                        entriesToBeDeleted.push(localEntry.entryKey);
                    }
                }

                if (entriesToBeDeleted.length) {
                    return this.deleteEntries(entriesToBeDeleted);
                } else {
                    return Q(true);
                }
            },
            /**
             * Loads server history and local history, merges them and returns promise resolved with history object
             *
             *      server history may be injected by using @param injectedServerHistory
             *
             * Returns promise resolved with history object
             *
             * @param {Object=} injectedServerHistory
             * @returns {Promise|Q.promise}
             */
            loadDatabase: function (injectedServerHistory) {
                var deferred = Q.defer();

                this.loadServer(injectedServerHistory)
                    .then(this.mergeWithLocalDatabase.bind(this))
                    .then(function (mergedHistory) {
                        this.history = mergedHistory;
                        deferred.resolve(mergedHistory);
                    }.bind(this))
                    .catch(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            },
            loadLocalDatabase: function (){
                if (this.database !== null) {
                    return this.database.loadHistory();
                } else {
                    return Q({undoList: [], redoList: [], lastEntry: {}});
                }
            },
            /**
             * Getter function
             *
             * @returns {*}
             */
            getUndoEntries: function () {
                return this.history.undoList;
            },

            /**
             * Getter function
             *
             * @returns {*}
             */
            getRedoEntries: function () {
                return this.history.redoList;
            },

            /**
             * Adds a record to database
             *
             * Returns promise resolved with record id
             *
             * @param {Object} data
             * @param {?String} entryKey
             * @returns {Promise|Q.promise}
             */
            addUndoEntry: function (data, entryKey) {
                var deferred = Q.defer();
                data.sessionId = this.sessionId;

                if (typeof data === 'undefined') {
                    deferred.reject('data is undefined');
                } else {
                    this.database.add(data, entryKey)
                        .then(function (res) {
                            deferred.resolve(res);
                        })
                        .catch(function (err) {
                            deferred.reject(err);
                        });
                }
                return deferred.promise;
            },

            /**
             * Updates record {key} with {data}
             *
             * @param key
             * @param data
             * @returns {Promise|Q.promise}
             */
            updateEntry: function (key, data) {
                var deferred = Q.defer();
                this.database.update(key, data)
                    .then(function (previousData) {
                        deferred.resolve(previousData);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
                return deferred.promise;
            },
            /**
             * Deletes record of type redo from database
             *
             *
             * @returns {Promise|Q.promise}
             */
            deleteRedoEntries: function () {
                var deferred = Q.defer();
                this.database.deleteRedoEntries()
                    .then(function (previousData) {
                        deferred.resolve(previousData);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },

            /**
             * Deleted record with {toDeleteIds}
             *
             * @param toDeleteIds
             * @returns {Promise|Q.promise}
             */
            deleteEntries: function (toDeleteIds) {
                var deferred = Q.defer();
                if (Array.isArray(toDeleteIds) && toDeleteIds.length) {
                    this.database.deleteEntryIds(toDeleteIds)
                        .then(function (res) {
                            deferred.resolve(res);
                        })
                        .catch(function (err) {
                            deferred.reject(err);
                        });
                } else {
                    deferred.resolve(true);
                }
                return deferred.promise;
            },
            /**
             *
             * @param {String} undoSessionId
             * @returns {Promise|Q.promise}
             */
            deleteEntriesFromSession: function deleteEntriesFromSession(undoSessionId) {
                return this.database.deleteEntriesFromSession(undoSessionId);
            },
            /**
             *
             * @returns {Promise|Q.promise}
             */
            getActiveUndoSession: function () {
                var deferred = Q.defer();
                this.database.getStatic('-static-undoRedo/activeSession')
                    .then(function (data) {
                        deferred.resolve(data);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    })
                    .done();
                return deferred.promise;
            },

            /**
             *
             * @param {Object} sessionData
             * @returns {Promise|Q.promise}
             */
            setActiveUndoSession: function (sessionData) {
                var deferred = Q.defer();
                this.database.setStatic('-static-undoRedo/activeSession', sessionData)
                    .then(function (data) {
                        deferred.resolve(data);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    })
                    .done();
                return deferred.promise;
            }
        });

        return Storage;
    });



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/Storage.js
 ** module id = 909
 ** module chunks = 0
 **/